import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { AuthModule } from '../auth/auth.module';
import { NgSignaturePadModule } from '../ng-signaturepad/ng-signaturepad.module';
import { CollapsableComponent } from '../shared/collapsable/collapsable.component';
import { RadioInputComponent } from '../shared/radio-input/radios-input.component';
import { SharedModule } from '../shared/shared.module';
import { BeneficiariesRoutingModule } from './beneficiaries-routing.module';
import { BeneficiaryDetailsComponent } from './beneficiary-details/beneficiary-details.component';
import { ComplementComponent } from './beneficiary-details/complement/complement.component';
import { DocumentDetailsComponent } from './beneficiary-details/documents/document-details/document-details.component';
import { DocumentComponent } from './beneficiary-details/documents/document.component';
import { EmploymentComponent } from './beneficiary-details/employment/employment.component';
import { PersonalDataComponent } from './beneficiary-details/personal-data/personal-data.component';
import { BeneficiaryDuplicateCheckComponent } from './beneficiary-duplicate-check/beneficiary-duplicate-check.component';
import { AssessmentDetailsComponent } from './beneficiary-folder/assessment/assessment-details/assessment-details.component';
import { AssessmentSignatureComponent } from './beneficiary-folder/assessment/assessment-signature/assessment-signature.component';
import { AssessmentComponent } from './beneficiary-folder/assessment/assessment.component';
import { BeneficiaryFolderComponent } from './beneficiary-folder/beneficiary-folder.component';
import { ContractDetailsComponent } from './beneficiary-folder/contract/contract-details/contract-details.component';
import { ContractComponent } from './beneficiary-folder/contract/contract.component';
import { FseDetailsComponent } from './beneficiary-folder/fse/fse-details/fse-details.component';
import { FSEComponent } from './beneficiary-folder/fse/fse.component';
import { InterviewDetailsComponent } from './beneficiary-folder/interview/interview-details/interview-details.component';
import { InterviewComponent } from './beneficiary-folder/interview/interview.component';
import { StageDetailsComponent } from './beneficiary-folder/stages/stage-details/stage-details.component';
import { StageComponent } from './beneficiary-folder/stages/stage.component';
import { BeneficiaryListComponent } from './beneficiary-list/beneficiary-list.component';
import { BeneficiarySummaryExportComponent } from './beneficiary-summary/beneficiary-summary-export/beneficiary-summary-export.component';
import { BeneficiarySummaryComponent } from './beneficiary-summary/beneficiary-summary.component';
import { ProfilePerimeterDirective } from './profile-perimeter.directive';
import { RsjDetailsComponent } from './rsj/rsj-details.component';
import { RsjInstructionCivilStatusComponent } from './rsj/rsj-instruction/rsj-instruction-details/rsj-instruction-civil-status/rsj-instruction-civil-status.component';
import { RsjInstructionCommitmentComponent } from './rsj/rsj-instruction/rsj-instruction-details/rsj-instruction-commitment/rsj-instruction-commitment.component';
import { RSJDetailsComponent } from './rsj/rsj-instruction/rsj-instruction-details/rsj-instruction-details.component';
import { RsjInstructionInsertionComponent } from './rsj/rsj-instruction/rsj-instruction-details/rsj-instruction-insertion/rsj-instruction-insertion.component';
import { RsjInstructionOtherDocumentsComponent } from './rsj/rsj-instruction/rsj-instruction-details/rsj-instruction-other-documents/rsj-instruction-other-documents.component';
import { RsjInstructionPaymentComponent } from './rsj/rsj-instruction/rsj-instruction-details/rsj-instruction-payment/rsj-instruction-payment.component';
import { RsjInstructionPersonalDataComponent } from './rsj/rsj-instruction/rsj-instruction-details/rsj-instruction-personal-data/rsj-instruction-personal-data.component';
import { RsjInstructionReservedDieComponent } from './rsj/rsj-instruction/rsj-instruction-details/rsj-instruction-reserved-die/rsj-instruction-reserved-die.component';
import { RsjInstructionResourcesComponent } from './rsj/rsj-instruction/rsj-instruction-details/rsj-instruction-resources/rsj-instruction-resources.component';
import { RsjInstructionComponent } from './rsj/rsj-instruction/rsj-instruction.component';
import { RsjPaymentInformationComponent } from './rsj/rsj-payment/rsj-payment-information/rsj-payment-information.component';
import { RsjPaymentComponent } from './rsj/rsj-payment/rsj-payment.component';
import { RsjPersonalDataComponent } from './rsj/rsj-personal-data/rsj-personal-data.component';

@NgModule({
  declarations: [
    AssessmentComponent,
    AssessmentDetailsComponent,
    BeneficiaryListComponent,
    BeneficiaryDetailsComponent,
    BeneficiaryFolderComponent,
    BeneficiarySummaryComponent,
    PersonalDataComponent,
    InterviewComponent,
    InterviewDetailsComponent,
    ContractComponent,
    ContractDetailsComponent,
    StageComponent,
    ComplementComponent,
    StageDetailsComponent,
    EmploymentComponent,
    DocumentComponent,
    DocumentDetailsComponent,
    FSEComponent,
    FseDetailsComponent,
    RsjInstructionComponent,
    ProfilePerimeterDirective,
    RSJDetailsComponent,
    BeneficiarySummaryExportComponent,
    RsjDetailsComponent,
    RsjPersonalDataComponent,
    RsjPaymentComponent,
    RsjInstructionCivilStatusComponent,
    RsjPaymentInformationComponent,
    RsjInstructionPersonalDataComponent,
    RsjInstructionResourcesComponent,
    RsjInstructionInsertionComponent,
    RsjInstructionCommitmentComponent,
    RsjInstructionPaymentComponent,
    RsjInstructionOtherDocumentsComponent,
    RsjInstructionReservedDieComponent,
    BeneficiaryDuplicateCheckComponent,
    AssessmentSignatureComponent,
  ],
  imports: [
    NgSignaturePadModule,
    CommonModule,
    BeneficiariesRoutingModule,
    SharedModule,
    AuthModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    RouterModule,
    FontAwesomeModule,
    NgSelectModule,
    RadioInputComponent,
    CollapsableComponent,
  ],
})
export class BeneficiariesModule {}
